import React from 'react';

import PropTypes from 'prop-types';
import styledC from 'styled-components';

import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';

import { FooterActionsProps } from '../types';

const FooterActions = styledC.div`
  & > button {
    margin: 0 10px 10px 0;
  }
`;

const DefaultFooterActions = ({ today }: FooterActionsProps) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <FooterActions>
      <Button onClick={today} size={Button.SIZES.SMALL}>
        {T.translate('TODAY')}
      </Button>
    </FooterActions>
  );
};

DefaultFooterActions.displayName = 'DefaultFooterActions';

DefaultFooterActions.propTypes = {
  today: PropTypes.func.isRequired,
};

export default DefaultFooterActions;
